import { motion } from 'framer-motion';

/**
 * SoftButton — pill button in the gallery artwork language.
 *   bg / border / text follow variants. Always rounded-full so the artwork
 *   does not feel like a dashboard.
 */
const VARIANTS = {
  primary: {
    bg: 'rgba(255,255,255,0.08)',
    border: 'rgba(255,255,255,0.20)',
    color: '#F5F5F5',
    hoverBg: 'rgba(255,255,255,0.14)',
    hoverBorder: 'rgba(255,255,255,0.40)',
  },
  cyan: {
    bg: 'rgba(144,224,239,0.10)',
    border: 'rgba(144,224,239,0.35)',
    color: '#9BE6F4',
    hoverBg: 'rgba(144,224,239,0.18)',
    hoverBorder: 'rgba(144,224,239,0.70)',
  },
  ghost: {
    bg: 'transparent',
    border: 'rgba(255,255,255,0.16)',
    color: 'rgba(245,245,245,0.7)',
    hoverBg: 'rgba(255,255,255,0.06)',
    hoverBorder: 'rgba(255,255,255,0.30)',
  },
  danger: {
    bg: 'rgba(232,139,160,0.10)',
    border: 'rgba(232,139,160,0.35)',
    color: '#E88BA0',
    hoverBg: 'rgba(232,139,160,0.18)',
    hoverBorder: 'rgba(232,139,160,0.70)',
  },
};

export default function SoftButton({
  children,
  onClick,
  variant = 'primary',
  disabled,
  testId,
  size = 'md',
  className = '',
  type = 'button',
}) {
  const v = VARIANTS[variant] || VARIANTS.primary;
  let pad = 'px-6 py-3 text-[12px]';
  if (size === 'sm') pad = 'px-4 py-1.5 text-[11px]';
  else if (size === 'lg') pad = 'px-9 py-4 text-[13px]';
  else if (size === 'xl') pad = 'px-12 py-5 text-[13px] sm:text-[14px]';
  return (
    <motion.button
      type={type}
      onClick={onClick}
      disabled={disabled}
      data-testid={testId}
      data-clickable="true"
      whileHover={!disabled ? { y: -1, backgroundColor: v.hoverBg, borderColor: v.hoverBorder } : undefined}
      whileTap={!disabled ? { scale: 0.97 } : undefined}
      className={`inline-flex items-center justify-center gap-2 ${pad} rounded-full font-mono tracking-[0.18em] uppercase font-medium transition-colors duration-200 disabled:opacity-40 disabled:cursor-not-allowed ${className}`}
      style={{
        color: v.color,
        backgroundColor: v.bg,
        border: `1px solid ${v.border}`,
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)',
      }}
    >
      {children}
    </motion.button>
  );
}
